"use strict";

angular.module("admin")

	.controller("AdminConsumersCtrl", ["consumers", "$scope", "Utils", "$uibModal", "AdminConsumersService", "toastr", "$location", "SecurityService", function (consumers, $scope, Utils, $uibModal, AdminConsumersService, toastr, $location, SecurityService) {
		$scope.data = {
			consumers: consumers.data,
			consumer: consumers.data ? consumers.data : {},
			hasAccessToOpendataConsumer: false,
			hasAccessToPigmaConsumer: false
		};

		$scope.edit = function () {
			$scope.apiPersist(() => AdminConsumersService.save($scope.data.consumer), "Sauvegarde du consommateur");
		};

		$scope.delete = function (id) {
			// on met à jour la liste si succès de la suppression
			const onSuccess = $scope.data.consumers = $scope.data.consumers.filter(e => e.id !== id);
			$scope.apiPersist(() => AdminConsumersService.delete(id), "Suppression du consommateur", onSuccess);
		};

		if (SecurityService.hasRight('openDataSoftConsumer')){
			$scope.data.hasAccessToOpendataConsumer = true;
		}

		if (SecurityService.hasRight('pigmaConsumer')){
			$scope.data.hasAccessToPigmaConsumer = true;
		}

		/**
		 * Lance un appel vers l'api pour persister les changements
		 * @param apiCall Fonction d'appel vers l'api
		 * @param operationLabel Nom de l'opération
		 * @param onSuccess Fonction callback sur succès
		 */
		$scope.apiPersist = (apiCall, operationLabel, onSuccess) => {
			apiCall().then(() => {
				if (angular.isFunction(onSuccess)) {
					onSuccess();
				}
				toastr.success("", operationLabel + " réussie");
				$location.path("/admin/consumers");
			}).catch((response) => {
				const data = response.data;
				let errorMessage = "Erreur lors de la " + operationLabel;
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};


		$scope.changeNotificationUrl = () => {
			if ($scope.data.consumer.notification === false) {
				$scope.data.consumer.notificationUrls = [];
			}
		};

		$scope.addNotificationUrl = function (url) {
			if($scope.data.consumer.notificationUrls === undefined){
				$scope.data.consumer.notificationUrls = [];
			}
			if(!$scope.data.consumer.notificationUrls.includes(url) && url){
				$scope.data.consumer.notificationUrls.push(url);
			}
		};

		$scope.removeNotificationUrl = function (url) {
			$scope.data.consumer.notificationUrls = $scope.data.consumer.notificationUrls.filter(value => value !== url);
		};

	}]);
